<div [ngSwitch]="documentData.type">
  <div *ngSwitchCase="'/angular-templates/v1/fields/editor'" fxLayout="row">
    <div fxFlex>
      <app-tiny-editor [disabled]="disabled" [content]="documentData.value" [id]="id" [isActive]="isActive" (editorContentChange)="change($event)"></app-tiny-editor>
      <div>{{isSaved ? 'Guardado' : (isSaving ? 'Guardando' : '')}}</div>
    </div>
  </div>
  <div *ngSwitchCase="'/angular-templates/v1/fields/textarea'" fxLayout="row">
    <mat-form-field fxFlex appearance="outline" color="primary">
      <mat-label>{{documentData.key}}</mat-label>
      <textarea matInput placeholder="{{documentData.key}}" matTextareaAutosize matAutosizeMinRows="1" [formControl]="inputCtrl"></textarea>
      <mat-hint align="end">{{isSaved ? 'Guardado' : (isSaving ? 'Guardando' : '')}}</mat-hint>
    </mat-form-field>
  </div>
</div>
